import {
  useDataProvider,
  useLocalization,
  useSnackbar,
} from '@ui-framework/index';
import {
  ButtonContainer,
  IconLibrary,
  PermissionButton,
} from '@product-framework/index';
import { FormattedMessage } from 'react-intl';
import Form from '@product-framework/components/AdvancedForms/Form';
import { useCallback, useRef } from 'react';
import schema from './edit.json';
import validationSchema from './validations';
import { useServiceProvider } from '../../../../providers/ServiceProviderProvider';

const PERMISSION_SP = 'SERVICEPROVIDERPROFILE';

function PerfomanceForm({ onChange = () => undefined, formId, config }) {
  const { formatMessage } = useLocalization();
  const formRef = useRef();
  const snackbar = useSnackbar();
  const provider =
    process.env.NODE_ENV === 'development' ? 'sxclServices' : 'default';
  const { get, put } = useDataProvider(provider);

  const { serviceProviderId } = useServiceProvider();

  const { performanceApiUrl: apiUrl } = config.api;

  const fetchDefaultValues = useCallback(async () => {
    const response = await get(apiUrl);
    if (response?.ok) {
      const result = {
        data: response?.data,
        errors: null,
      };

      return result;
    }
    const result = {
      data: null,
      errors: response?.errors,
    };
    return result;
  }, [serviceProviderId]);

  const onSubmit = async data => {
    const response = await put(apiUrl, { ranking: data.ranking });

    if (response?.ok) {
      snackbar.showMessage(
        formatMessage({
          id: 'SERVICE_PROVIDER_PERFORMANCE_WAS_SAVED_SUCCESSFULLY',
          defaultMessage: 'Service Provider performance was saved successfully',
        }),
      );
      return {
        nextValues: response?.data,
        errors: null,
        callback: () => {
          onChange();
        },
      };
    }
    return {
      nextValues: data,
      errors: response?.errors,
    };
  };

  return (
    <Form
      formId={formId}
      ref={formRef}
      permissionEntities={[PERMISSION_SP]}
      onSubmit={onSubmit}
      schema={schema}
      fetchDefaultValues={fetchDefaultValues}
      validationSchema={validationSchema(formatMessage)}>
      <ButtonContainer>
        <PermissionButton
          variant="contained"
          permissionName="CAN_UPDATE_SP_PERFORMANCE"
          startIcon={<IconLibrary.Save />}
          color="primary"
          onClick={() => formRef.current?.submit({ formId })}>
          <FormattedMessage
            id="SAVE_PERFORMANCE"
            defaultMessage="Save Performance"
          />
        </PermissionButton>
        <PermissionButton
          permissionName="CAN_UPDATE_SP_PERFORMANCE"
          variant="contained"
          color="primary"
          startIcon={<IconLibrary.Reset />}
          onClick={() => formRef.current?.reset()}>
          <FormattedMessage id="RESET" defaultMessage="Reset" />
        </PermissionButton>
      </ButtonContainer>
    </Form>
  );
}
export default PerfomanceForm;
